import React from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import DashboardHeader from '../../components/admincomponents/DashboardHeader';
import PackageDetails from '../../components/admincomponents/PackegeDetails';

function ViewPackeges({onLogout}) {
  return (
    <>
      <DashboardHeader onLogout={onLogout}/>
      <PackageDetails />            
    </>
  );
}

export default ViewPackeges;
